import {
  BarcodeOutlined,
  CheckCircleOutlined,
  EditOutlined,
  ImportOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { PageHeader, Popconfirm, message, Checkbox, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, dineroDisabledMask, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import HeaderActions from "../../../Components/HeaderActions";
import CambiarFamilia from "../Insumos/CambiarFamilia/CambiarFamilia";
import IconArrowsShuffle from "../../../Icons/IconArrowsShuffle";

class Activos extends Component {
  tableRef = null;
  state = {
    idEditarActivo: null,
    modalAgregarFamilia: false,
    todasActivos: [],
    loading: false,
    valor: 3,
    totalRecords: 0,
    idCambiarFamilia: null,
    modalImprimirCodigoDeBarras: false,
    modalImprimirCodigoDeBarrasId: null,
    textoFiltro: "",
  };
  consultarActivos(params) {
    this.setState({ loading: true })
    axios
      .post(
        "activos/selectTodosActivos",
        { empresaId: this.props.empresaId, ...params },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasActivos: res.data.data.map((data) => {
              let compraVenta
              if (data.compra && data.venta) {
                compraVenta = 'Ambos'
              } else if (data.compra) {
                compraVenta = 'Compra'
              } else if (data.venta) {
                compraVenta = 'Venta'
              } else {
                compraVenta = 'Ninguno'
              }
              return {
                ...data,
                compraVenta
              }
            }),
            totalRecords: res.data.totalRecords || 0,
            loading: false
          });
        } else {
          this.setState({ todasActivos: [], loading: false });
        }
      });
  }
  deshabilitarActivo(value) {
    axios
      .post(
        "insumos/deshabilitarInsumo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Activo deshabilitado");
        } else {
          message.error("Sucedio un eror y no se pudo deshabilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  habilitarActivo(value) {
    axios
      .post(
        "insumos/habilitarInsumo",
        { insumoId: value, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          message.success("Activo habilitado");
        } else {
          message.error("Sucedio un eror y no se pudo habilitar");
        }
        if (this.tableRef) {
          this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
      });
  }
  imprimirCodigoDeBarras(value) {
    this.setState({ modalImprimirCodigoDeBarras: true, modalImprimirCodigoDeBarrasId: value });
  }
  agregarActivo() {
    this.props.history.push("/panel/agregarInsumo", {activo: true});
  }
  editarActivo(id) {
    this.props.history.push("/panel/editarInsumo", { id, activo: true });
  }
  abrirAgregarFamilia() {
    this.setState({ modalAgregarFamilia: true });
  }
  cerrarAgregarFamilia() {
    this.setState({ modalAgregarFamilia: false });
    this.consultarActivos();
  }

  importarActivos() {
    this.props.history.push('/panel/importarInsumos', { activo: true });
  }

  cambiarFamilia(id) {
    this.setState({ idCambiarFamilia: id });
  }

  cerrarCambiarFamilia() {
    this.setState({ idCambiarFamilia: null });
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({ valor: this.state.valor });
    }
  }

  cerrarModalCodigoDeBarras() {
    this.setState({ modalImprimirCodigoDeBarras: false, modalImprimirCodigoDeBarrasId: null });
  }


  render() {
    const columns = [
      {
        title: "C / V",
        dataIndex: "compraVenta",
        key: "compraVenta",
        width: "10%",
      },
      {
        title: "Codigo",
        dataIndex: "codigo",
        key: "codigo",
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
          if (a.codigo < b.codigo) {
            return -1;
          }
          if (a.codigo > b.codigo) {
            return 1;
          }
          return 0;
        },
        buscar: "codigo",
        width: "5%",
      },
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        defaultSortOrder: 'ascend',
        sorter: true,
        buscar: "clave",
        width: "10%",
      },
      {
        title: "Descripcón",
        dataIndex: "descripcion",
        key: "descripcion",
        sorter: true,
        buscar: "descripcion",
        width: "20%",
      },
      {
        title: "Inventariable",
        dataIndex: "inventariable",
        key: "inventariable",
        render: (value) => <Checkbox checked={value} />,
        align: 'center',
        width: "6%",
      },
      {
        title: "U. Costo",
        dataIndex: "costo",
        key: "costo",
        sorter: true,
        render: (value) => dineroDisabledMask(value),
        width: "8%",
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        buscar: "unidad",
        width: "6%",
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        buscar: "familia",
        width: "21%",
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        align: "center",
        width: "20%",
        onHeaderCell: () => ({
          style: { textAlign: 'center', padding: '4px' }
        }),
        onCell: () => ({
          className: "acciones-sin-hover",
          style: { textAlign: 'center', padding: '4px' }
        }),
        render: (value, index) => {
          let buttons = [];

          // Botón Código de Barras
          buttons.push(
            <Tooltip title="Código de Barras" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                key={`barcode-${index}`}
                type="default"
                size="small"
                blanco
                icon={<BarcodeOutlined />}
                onClick={() => this.imprimirCodigoDeBarras(value._id)}
              >
              </ButtonItem>
            </Tooltip>
          );

          // Botón Editar
          if (this.props.permisoEditarInsumo) {
            buttons.push(
              <Tooltip title="Editar Activo" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`editar-${index}`}
                  type="default"
                  size="small"
                  cyan
                  icon={<EditOutlined />}
                  onClick={() => this.editarActivo(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          // Botón Habilitar/Deshabilitar
          if (value.estado === 1) {
            buttons.push(
              <Popconfirm
                key={`deshabilitar-${index}`}
                title="Seguro que quieres deshabilitar este activo"
                onConfirm={() => this.deshabilitarActivo(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Deshabilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    lima
                    icon={<CheckCircleOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          } else {
            buttons.push(
              <Popconfirm
                key={`habilitar-${index}`}
                title="Seguro que quieres habilitar este activo"
                onConfirm={() => this.habilitarActivo(value._id)}
                okText="Si"
                cancelText="No"
              >
                <Tooltip title="Habilitar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                  <ButtonItem
                    type="default"
                    size="small"
                    rojo2
                    icon={<StopOutlined />}
                  >
                  </ButtonItem>
                </Tooltip>
              </Popconfirm>
            );
          }

          // Botón Cambiar Familia
          if (this.props.permisoEditarInsumo) {
            buttons.push(
              <Tooltip title="Cambiar Familia" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  key={`familia-${index}`}
                  type="default"
                  size="small"
                  azulMarino2
                  icon={<IconArrowsShuffle />}
                  onClick={() => this.cambiarFamilia(value._id)}
                >
                </ButtonItem>
              </Tooltip>
            );
          }

          return <div className="acciones-container">{buttons}</div>;
        },
      },
    ];
    return (
      <>
        <PageHeader
          title={this.props.taxidermia ? "Formas" : "Activos"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {window.innerWidth > 1000 && (
                  <>
                    <SegmentedItem
                      options={[{ label: 'Venta', value: 1 }, { label: 'Compra', value: 2 }, { label: 'Ambos', value: 3 }, { label: 'Ninguno', value: 4 }, { label: 'Todos', value: 5 }, { label: 'Deshabilitados', value: 6 }]}
                      onChange={(value) => {
                        if (this.tableRef) {
                          this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                        }
                        this.setState({ valor: value })
                      }}
                      value={this.state.valor}
                    />
                    <div className="header-divider"></div>
                  </>
              )}
              <HeaderActions>
                {this.props.permisoImportarInsumo && (
                  <ButtonItem
                    type="default"
                    icon={<ImportOutlined />}
                    onClick={() => this.importarActivos()}
                  >
                    Importar {this.props.taxidermia ? "Formas" : "Activos"}
                  </ButtonItem>
                )}
              </HeaderActions>

              {this.props.permisoAgregarInsumo && (
                <ButtonItem
                  type="primary"
                  onClick={() => this.agregarActivo()}
                  olivo
                  className="botonAgregar"
                >
                  Agregar {this.props.taxidermia ? "Forma" : "Activo"}
                </ButtonItem>
              )}
            </div>
          }
        />
        <TableItemDinamico
          ref={(ref) => this.tableRef = ref}
          onRef={(ref) => this.tableRef = ref}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarActivos.bind(this)}
          size="small"
          dataSource={this.state.todasActivos}
          columns={columns}
          pagination={false}
          onRow={(record) => ({
            onDoubleClick: () => this.editarActivo(record._id),
          })}
          setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
          filterStorageKey={"activosFiltrosTabla" + this.props.empresaId}
          setValor={(valor) => this.setState({ valor })}
          valorDefault={3}
          valorTextoDefault={""}
        />
        <CambiarFamilia
          visible={this.state.idCambiarFamilia !== null}
          id={this.state.idCambiarFamilia}
          cerrarCambiarFamilia={this.cerrarCambiarFamilia.bind(this)}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
    permisoAgregarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccd1cf30e81b54183cf75")?.activado,
    permisoEditarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "615ccd41f30e81b54183cf76")?.activado,
    permisoImportarInsumo: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "67509111798d4e004368723e")?.activado,
  };
};

export default connect(mapStateToProps)(Activos);
